// Status vocabulary mirrors internal/usecase/status.go. Keep the two in step:
// the backend owns the derivation, this file owns only how it reads.

export const STATUS_LABELS = {
  green: "Healthy",
  amber: "At risk",
  red: "Over budget",
  unbudgeted: "Unbudgeted",
  inactive: "No spend",
  no_forecast: "No forecast",
};

export function statusLabel(status) {
  return STATUS_LABELS[status] ?? "—";
}

// Only the three colour states carry a tone. Unbudgeted is deliberately neutral:
// it is a gap to chase, not a breach, and rendering it as danger would drown the
// page in false alarms on a hierarchy where most leaves never carry spend.
export function statusTone(status) {
  switch (status) {
    case "green":
      return "success";
    case "amber":
      return "warning";
    case "red":
      return "danger";
    default:
      return "neutral";
  }
}

// formatVariance renders forecast-minus-cap as a signed percentage. Uses a real
// minus sign (U+2212) so the column aligns with the app's other signed figures.
//
// Rounding is applied to the magnitude and the sign reapplied, so a negative
// half rounds away from zero (-3.75 → -3.8) like its positive twin. Math.round
// alone rounds halves toward +Infinity, which would show -3.75% as -3.7%.
export function formatVariance(variance) {
  if (!variance || typeof variance.pct !== "number") return "—";
  const pct = variance.pct * 100;
  const magnitude = Math.round(Math.abs(pct) * 10) / 10;
  if (magnitude === 0) return "0.0%";
  const sign = pct > 0 ? "+" : "−";
  return `${sign}${magnitude.toFixed(1)}%`;
}
